import { useMutation } from "@apollo/client";
import queryString from "query-string";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import FlashContext from "components/FlashMessages/FlashContext";
import RedirectToLogin from "components/redirect/RedirectToLogin";
import SystemMessage from "components/SystemMessage";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import useTypedContext from "hooks/useTypedContext";

import { CONFIRM_TOKEN } from "./gql";

const CLILogin = () => {
  const { search } = useLocation();
  const { key, port } = queryString.parse(search);
  const { onError } = useTypedContext(FlashContext);

  const handleSetItem = (key: string, value: string) => localStorage.setItem(key, value);

  const [getCLIConfirmationToken, { data, loading }] = useMutation<{
    cliConfirmationToken: string;
  }>(CONFIRM_TOKEN);
  const isCLILoginProcessing = !!sessionStorage.getItem("cliLoginProcessing");

  const handleCliLogin = () => {
    if (data?.cliConfirmationToken) {
      sessionStorage.removeItem("cliLoginProcessing");
      window.location.href = `${window.location.origin}/cli_auth?token=${data.cliConfirmationToken}&port=${port}`;
    }
  };

  useEffect(() => {
    const asyncEffect = async () => {
      try {
        if (key && isCLILoginProcessing && !data) {
          await getCLIConfirmationToken({ variables: { pubKey: key } });
        }
      } catch (error) {
        onError(error);
      }
    };

    void asyncEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, isCLILoginProcessing]);

  if (!key) {
    return <Navigate to="/auth_failure" replace />;
  }

  if (!sessionStorage.getItem("cliLoginProcessing")) {
    sessionStorage.setItem("cliLoginProcessing", "true");
    return <RedirectToLogin setItem={handleSetItem} />;
  }

  return (
    <SystemMessage
      title="Log in to the Spacelift CLI"
      message="When you are ready to authenticate press the button below"
    >
      <Box direction="column" gap="x-large" fullWidth>
        <Button
          variant="primary"
          onPress={handleCliLogin}
          loading={loading}
          disabled={!data?.cliConfirmationToken}
        >
          Login
        </Button>
      </Box>
    </SystemMessage>
  );
};

export default CLILogin;
